import { useSubmittedDocument } from "~/stores/useSubmittedDocument";

export const useSubmittedDocumentStore = (documentId: string) => {
  // const documentId = inject("documentId") as any;

  return useSubmittedDocument(documentId)();
};
